import "./our-services.css";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Trans } from "react-i18next";

export default function OurServices() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const services = [
    {
      icon: "fa-solid fa-laptop-code",
      title: "IT Solutions",
      description:
        "Custom IT services, application integration, and digital transformation strategies for enterprises to enhance operational efficiency.",
      link: "/services/it-solutions"
    },
    {
      icon: "fa-solid fa-user-tie",
      title: "IT Consulting Services",
      description:
        "Strategic IT consultation to streamline technology adoption, optimize workflows, and align IT with business objectives.",
      link: "/services/it-consulting-services"
    },
    {
      icon: "fa-solid fa-cloud",
      title: "Cloud Transformation",
      description:
        "Migrate securely to cloud platforms with scalable architectures, data protection, and cost optimization solutions.",
      link: "/services/cloud-transformation"
    },
    {
      icon: "fa-solid fa-chart-line",
      title: "Business Analytics",
      description:
        "Leverage analytics to extract actionable insights, improve decision-making, and drive growth through data intelligence.",
      link: "/services/business-analytics"
    },
    {
      icon: "fa-solid fa-mobile-screen-button",
      title: "Application Management",
      description:
        "Comprehensive management of enterprise apps, including modernization, updates, and performance optimization.",
      link: "/services/application-management"
    },
    {
      icon: "fa-solid fa-dolly",
      title: "ERP, Procurement & Supply Chain",
      description:
        "Integrate ERP and supply chain systems to streamline procurement, logistics, and resource management.",
      link: "/services/erp-procurement-and-supply-chain"
    },
    {
      icon: "fa-solid fa-shield-halved",
      title: "DevOps & Cyber Security",
      description:
        "Enhance delivery speed and security through DevOps automation, threat prevention, and continuous monitoring.",
      link: "/services/devops-and-cyber-security"
    },
    {
      icon: "fa-solid fa-people-carry-box",
      title: "Build, Operate & Transfer",
      description:
        "Partner with us to build, manage, and seamlessly transfer operations while maintaining full control.",
      link: "/services/build-operate-transfer"
    },
    {
      icon: "fa-solid fa-envelope",
      title: "Get in Touch",
      description:
        "Reach out to us for any requirements you have in the org management to niche services like ERP, Analytics Support and Cyber Security.",
      link: "/contact-us",
      contact: true
    }
  ];

  return (
    <div className="our-services-container">
      <h6 className="our-services-heading">{t("Services")}</h6>
      <h1 className="our-services-main-heading">
        <Trans i18nKey="Expert Consulting, Innovative Solutions and Reliable Support">
          Expert Consulting, Innovative Solutions <br /> and Reliable Support
        </Trans>
      </h1>
      <p className="our-services-desc">
        {t("From IT consulting to cloud transformation, our wide range of services cover every aspect of your organization’s technology journey. Our expert team ensures robust, scalable, and secure solutions tailored for your growth.")}
      </p>

      <div className="services-grid">
        {services.map((service, index) => (
          <div
            key={index}
            className={`service-card ${service.contact ? "contact-card" : ""}`}
          >
            <div className="card-inner">
              {/* FRONT SIDE */}
              <div className="card-front">
                <div className="icon-circle">
                  <i className={service.icon}></i>
                </div>
                <h3>{t(service.title)}</h3>
                <p>{t(service.description)}</p>
                <button className="view-btn card-back-view-btn" type="button" onClick={() => navigate(service.link)}>
                  {service.contact ? t("Contact Us") : t("View Details")}{" "}
                  <i className="fas fa-arrow-right"></i>
                </button>
              </div>

              {/* BACK SIDE (not for contact card) */}
              {!service.contact && (
                <div className="card-back">
                  <div>
                    <h3>{t(service.title)}</h3>
                    <p>{t(service.description)}</p>
                  </div>
                  <button className="view-btn card-back-view-btn" type="button" onClick={() => navigate(service.link)}>
                    {t("View Details")} <i className="fas fa-arrow-right"></i>
                  </button>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
